import React from 'react';
import { getBookCoverImage } from '../utils/books';

function BookCard({ book, isFlipped, onToggle }) {
  if (!book) return null;

  return (
    <div
      className={`book-card ${book.featured ? 'featured' : ''} ${isFlipped ? 'flipped' : ''}`}
      onClick={onToggle}
    >
      {book.featured && <div className="featured-banner">Featured</div>}
      <div className="card-inner">
        <div className="card-front">
          <div className="card-content">
            <img
              src={getBookCoverImage(book)}
              alt={`${book.name || 'Unknown'} cover`}
              className="book-cover"
              loading="lazy"
              onError={(e) => {
                e.target.src = '/imgs/The_Covered_Wagon.png';
              }}
            />
            <h3>{book.name || 'Unknown Book'}</h3>
            <p className="click-hint">Click to see details</p>
          </div>
        </div>
        <div className="card-back">
          <div className="card-content">
            <h3>{book.name || 'Unknown Book'}</h3>
            <p><strong>Author:</strong> {book.author || 'Unknown'}</p>
            <p><strong>Genre:</strong> {book.genre || 'Unknown'}</p>
            <p><strong>Parts:</strong> {book.parts || 'N/A'}</p>
            <p><strong>Published:</strong> {book.publish_year || 'N/A'}</p>
            <p><strong>Uploaded:</strong> {book.uploaded_date || 'N/A'}</p>
            <div className="book-links">
              {(book.youtube_links || (book.youtube_link ? [book.youtube_link] : []))
                .filter(Boolean)
                .map((url, i, arr) => (
                  <a
                    key={`yt-${i}`}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    YouTube{arr.length > 1 ? ` ${i + 1}` : ''}
                  </a>
                ))}
              {(book.rumble_links || (book.rumble_link ? [book.rumble_link] : []))
                .filter(Boolean)
                .map((url, i, arr) => (
                  <a
                    key={`rb-${i}`}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Rumble{arr.length > 1 ? ` ${i + 1}` : ''}
                  </a>
                ))}
            </div>
            <p className="click-hint">Click to see cover</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookCard;
